<script setup lang="ts">
import { ETooltipBadgeTheme, ETooltipBadgeTone } from '@/interfaces';
import { EPosition } from 'common/enum/misc.enum';
import TooltipBadge from './TooltipBadge.vue';

const props = withDefaults(
  defineProps<{
    hideLabelWhenTooltip?: boolean;
    size?: 'md' | 'xs';
    tooltipText?: string;
  }>(),
  {
    hideLabelWhenTooltip: false,
    size: 'md',
    tooltipText: undefined,
  },
);
</script>

<template>
  <TooltipBadge
    :hide-label-when-tooltip="props.hideLabelWhenTooltip"
    :label="$t('general.deactivated')"
    :size="props.size"
    :theme="ETooltipBadgeTheme.FILLED"
    :tone="ETooltipBadgeTone.DANGER"
    :tooltip-position="EPosition.BOTTOM_LEFT"
    :tooltip-text="props.tooltipText"
  />
</template>
